export class Constant {
  static get BASE_API_URL() {
    return "https://tunashealthcaresystem.id/api";
  }
}
